import React from 'react';
import { Accent, SectionHeading } from './SectionHeading';
import { onePartItems } from '../../data/content';
export function OnePartSection() {
  return <section aria-labelledby="one-part-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-128" data-mp="13tuu1x4lkqj4">
      <div className="mx-auto max-w-3xl" data-id="element-129" data-mp="18p0fkuu3836o">
        <SectionHeading id="one-part-heading" eyebrow="What If I Only Use One Part?" title={<>
              Even One Resource Could <Accent data-id="element-131" data-mp="kx2347iwk1ry">Save You Hours.</Accent>
            </>} data-id="element-130" data-mp="1dm0oddibnk1h" />
        <ul className="mx-auto mt-10 max-w-xl border-t border-brand-charcoal/12" role="list" data-id="element-132" data-mp="kz64oitbwop2">
          {onePartItems.map(item => <li key={item} className="border-b border-brand-charcoal/12 py-4 text-center text-[16px] text-brand-charcoal sm:text-[17px]" data-id="element-133" data-mp="txi151gvmgpf">
              {item}
            </li>)}
        </ul>
        <p className="mx-auto mt-10 max-w-xl text-center text-[16px] font-semibold leading-relaxed text-brand-charcoal sm:text-[17px]" data-id="element-134" data-mp="25cdt1p4jaenx">
          Now imagine having an entire teaching system ready whenever you need it.
        </p>
      </div>
    </section>;
}